module.exports = __webpack_public_path__ + "static/img/certificate_img25.6625b01c.jpg";